export default __webpack_public_path__ + "static/media/371.b10c4f02.gif";